import { postRequest } from "../system/server-calls";
import responseHandler from "../system/server-response-handler";

const contactUs = (data) => {
  return postRequest(`ContactUs`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const contactUsService = { contactUs };
